/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { chatService } from './services';

const pathname = '/rooms';

export const ChatApi = {
  findRooms: async (entityID: string, roomType?: string) => {
    let url = pathname;
    const query = serialize({ entityID, roomType });
    url += query;

    try {
      const response = await chatService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
  createRoom: async (
    type: string,
    entityID: string,
    members: MemberInfo[],
    displayName?: string,
    avatar?: string
  ) => {
    let data: any = {
      type,
      entityID,
      members,
    };
    if (type === 'group') {
      data = { ...data, displayName, avatar };
    }
    try {
      const response = await chatService.post('/room', data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  addMember: async (roomID: string, newMemberID: string, role: string) => {
    const url = `${pathname}/${roomID}/add/${newMemberID}/${role}`;

    try {
      const response = await chatService.post(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
  addMembers: async (roomID: string, members: MemberInfo[]) => {
    try {
      const response = await chatService.post(
        `${pathname}/${roomID}/members`,
        members
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  getMembers: async (roomID: string) => {
    try {
      const response = await chatService.get(`${pathname}/${roomID}/members`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  findMessages: async (
    roomID: string,
    memberID: string,
    page: number,
    take: number,
    messageType?: string
  ) => {
    let url = `${pathname}/${roomID}/members/${memberID}/messages`;
    const skip = 0;
    const query = serialize({ page, take, skip, messageType });
    url += query;

    try {
      const response = await chatService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
  sendMessage: async (
    roomID: string,
    memberID: string,
    content: string,
    messageType: string
  ) => {
    const url = `${pathname}/${roomID}/members/${memberID}/messages`;

    try {
      const response = await chatService.post(url, {
        roomID,
        senderID: memberID,
        content,
        messageType,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  readAllMessages: async (roomID: string, memberID: string) => {
    const url = `${pathname}/${roomID}/members/${memberID}/messages/all`;

    try {
      const response = await chatService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface MemberInfo {
  memberID: string;
  role: string;
}
